import { Component, OnInit, ViewChild, HostListener, AfterViewInit, ChangeDetectorRef, Input, SimpleChanges } from '@angular/core';

import { MdbTablePaginationComponent, MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { Clientes } from '../cliente';
import { ClienteService } from '../cliente.service';
import { validarRuc } from '../validar-ruc';
import { validarCedula } from '../validar-cedula';
import { CatalogoService } from '../catalogo.service';
import { Catalogo } from '../catalogo';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.scss']
})
export class ClienteComponent implements OnInit {
  clientes: Clientes[]= [];
  listarCatalogo: Catalogo[]= [];
  listarCatalogoInformacion: Catalogo[]= [];
  clienteActuliza: Clientes;
  listaClientesActulizar: Clientes[] = [];
  editForm: FormGroup;
  esComercialMostrar:boolean;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  data: Clientes[] = [];
  previous: any = [];
  isLoadingResults = true;
  validaIdentificacion:boolean
  constructor(config: NgbModalConfig,  private modalService: NgbModal,private catalogoService:CatalogoService,private alertService: AlertService,private api: ClienteService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder) {
    config.backdrop = 'static';
    config.keyboard = false;

   }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }

  mensaje(content,codigo: string) {



    this.api.getCliente(codigo).subscribe((data: Clientes[]) => {
      console.log(data);
      data.forEach(item => {

        this.editForm.controls.nombrerazonsocial.setValue(item.nombrerazonsocial);
        this.editForm.controls.numeroidentificacion.setValue(item.numeroidentificacion);
        this.editForm.controls.direccion.setValue(item.direccion);
        this.editForm.controls.telefonoconvencional.setValue(item.telefonoconvencional);
        this.editForm.controls.celular.setValue(item.celular);
        this.editForm.controls.tipoCliente.setValue(item.tipoCliente);
        this.editForm.controls.codcliente.setValue(item.codcliente);
        console.log('codigo cliente' + item.codcliente);
        this.editForm.controls.tipoidentificacion.setValue(item.tipoidentificacion);
        this.editForm.controls.correo.setValue(item.correo);
        this.editForm.controls.credito.setValue(item.credito_dolares);
        this.editForm.controls.enviado.setValue(item.enviado);
        this.editForm.controls.creditoDias.setValue(item.credito_tiempo);
        this.editForm.controls.tipoAtributo.setValue(item.tipoCatalogo);
      });   





    }, err => {
      console.log(err);
      this.isLoadingResults = false;
    });
    this.modalService.open(content);
    //this.mdbModal.show();


  }

  ngOnChanges(changes: SimpleChanges){
    console.log(changes);
}
ngDoCheck(){


}


listarCliente(){

  this.api.getClientes(localStorage.getItem('id'))
  .subscribe((
    data: Clientes[]) => {
    this.clientes = data;
    console.log(this.clientes);
    this.mdbTable.setDataSource(this.clientes);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
}


  ngOnInit() {
    this.listarCliente();
this.ObtenerCatalogos();
let esComercial=localStorage.getItem('escentroComercial')
  if(esComercial!=null){
    if("SI"==esComercial){
    this.esComercialMostrar=true;
    }else{
      this.esComercialMostrar=false;
    }
  }else{
    this.esComercialMostrar=false;
  }
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ['', Validators.required],
      numeroidentificacion: ['', Validators.required],
      direccion: ['', Validators.required],
      telefonoconvencional: ['', Validators.required],
      celular: ['', Validators.required],
      correo: ['', Validators.required],
      tipoCliente: ['', Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ['', Validators.required],
      credito: [0, Validators.required],
      creditoDias: [0, Validators.required],
      enviado: [''],
      tipoAtributo:[''],
    });


  }

 ObtenerCatalogos(){
  this.catalogoService.listarCatalogo(localStorage.getItem('id'),'105')
  .subscribe((
    data: Catalogo[]) => {
    this.listarCatalogo = data;
     }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
  

    this.catalogoService.listarCatalogo(localStorage.getItem('id'),'106')
  .subscribe((
    data: Catalogo[]) => {
    this.listarCatalogoInformacion = data;
     }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
 }

  eliminarCliente(id: number) {
    this.api.eliminarCliente(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..");
        this.listarCliente();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );


  }

  agregarCliente(content) {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ['', Validators.required],
      numeroidentificacion: ['', Validators.required],
      direccion: ['', Validators.required],
      telefonoconvencional: ['', Validators.required],
      celular: ['', Validators.required],
      correo: ['', Validators.required],
      tipoCliente: ['', Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ['', Validators.required],
      credito: [0, Validators.required],
      creditoDias: [0, Validators.required],
      enviado: [''],
      tipoAtributo: [''],
    });

    this.modalService.open(content);
    this.listarCliente();
  }

  


  onChangeDias($event: Event) {
    //this.editForm.controls.creditoDias.setValue($event.);
    
  }
  actulizarCliente() {
    this.clienteActuliza = new Clientes();
    this.clienteActuliza.nombrerazonsocial = this.editForm.controls.nombrerazonsocial.value;
    this.clienteActuliza.numeroidentificacion = this.editForm.controls.numeroidentificacion.value;
    this.clienteActuliza.direccion = this.editForm.controls.direccion.value;
    this.clienteActuliza.telefonoconvencional = this.editForm.controls.telefonoconvencional.value;
    this.clienteActuliza.celular = this.editForm.controls.celular.value;
    this.clienteActuliza.tipoCliente = this.editForm.controls.tipoCliente.value;
    this.clienteActuliza.codcliente = this.editForm.controls.codcliente.value;
    this.clienteActuliza.correo = this.editForm.controls.correo.value;
      this.clienteActuliza.credito_dolares = this.editForm.controls.credito.value;
      this.clienteActuliza.credito_tiempo = this.editForm.controls.creditoDias.value;
    this.clienteActuliza.tipoidentificacion = this.editForm.controls.tipoidentificacion.value;
    
    this.clienteActuliza.idEmisor = Number(localStorage.getItem('id'));
    this.clienteActuliza.enviado='S';
    this.clienteActuliza.tipoCatalogo = this.editForm.controls.tipoAtributo.value;
    this.listaClientesActulizar[0] = this.clienteActuliza;
    
    if (this.clienteActuliza.numeroidentificacion.length<=10){
      if (validarCedula(this.clienteActuliza.numeroidentificacion)){
        this.validaIdentificacion=true;
      }

    }
    if (this.clienteActuliza.numeroidentificacion.length>10){
      if (validarRuc(this.clienteActuliza.numeroidentificacion)){
        this.validaIdentificacion=true;
      }

    }   
   if (this.validaIdentificacion==true){
   

    this.api.setActulizarCliente(this.listaClientesActulizar).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..");
        this.mdbModal.hide();
        this.listarCliente();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );

    }else{
      this.alertService.danger("Verifique cedula o ruc");
      
    }
   
   

  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(5);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.clientes = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.clientes = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

}
